import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FinalCTASection() {
  return <section className="py-24 bg-marron text-white text-center" data-id="element-33">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-34">
        <h2 className="text-3xl sm:text-4xl font-heading font-bold text-white mb-6" data-id="element-35">
          No Tenés que "Acostumbrarte" a Sentirte Así.
        </h2>

        <p className="text-lg text-crema/80 mb-4" data-id="element-36">
          No necesitás otra pastilla. Necesitás un plan que trabaje{' '}
          <em className="text-mostaza not-italic" data-id="element-37">con</em> tu cuerpo, no en su
          contra.
        </p>

        <p className="text-lg text-crema/80 mb-10" data-id="element-38">
          Unite a las más de 50.000 personas que ya están usando estas fórmulas
          para recuperar su energía, su claridad y su comodidad — desde su
          propia cocina.
        </p>

        <a href="#oferta" className="inline-flex flex-col items-center justify-center px-10 py-5 bg-oliva hover:bg-oliva-dark text-white font-bold rounded-xl shadow-xl transition-all transform hover:-translate-y-1 group w-full sm:w-auto" data-id="element-39">
          <span className="flex items-center text-xl" data-id="element-40">
            🌿 QUIERO VOLVER A SER YO — EMPEZAR HOY
            <ArrowRight className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-41" />
          </span>
          <span className="text-sm font-normal mt-1 opacity-90" data-id="element-42">
            Acceder al Manual Digital con 75% de descuento + 2 guías de regalo →
          </span>
        </a>

        <p className="mt-6 text-sm text-crema/50" data-id="element-43">
          🔒 Pago seguro · Acceso inmediato · Garantía 7 días sin preguntas
        </p>
      </div>
    </section>;
}